import React from 'react';
import { useForm } from 'react-hook-form';
import MultySelect from '../UI/MultiSelect';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ReactComponent as TooltipIcon } from '../../assets/icons/tooltip.svg';
import { PAYMENT_TYPES } from '../../constans';

const FrameFive = ({ onSubmit, onChangeHandler, setTerms, terms, handleMultiChange, inputValue, selectValue }) => {
  const { register, handleSubmit } = useForm();

  const onChangeTermsHander = event => {
    const checked = event.target.checked;
    checked ? setTerms(true) : setTerms(false);
  }


  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <fieldset>
        <div className="tooltip-container-label">
          <label htmlFor="tp">Does your business sell third-party certified environmentally-friendly products?<span>*</span></label>
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip id="button-tooltip">
                Does your business sell environmentally friendly products?  If so, indicate yes.
              </Tooltip>
            }
          >
            <TooltipIcon />
          </OverlayTrigger>
        </div>
        <div className="d-flex">
          <div className="radio-wrapper">
            <input ref={register({ required: true })} type="radio" value={true} name="env_products" id="third-party-yes" />
            <label htmlFor="third-party-yes">Yes</label>
          </div>
          <div className="radio-wrapper">
            <input ref={register({ required: true })} type="radio" value={false} name="env_products" id="third-party-no" defaultChecked />
            <label htmlFor="third-party-no">No</label>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <div className="tooltip-container-label">
          <label htmlFor="contract_num">Does your business accept credit cards? <span>*</span></label>
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip id="button-tooltip">
                Does your business take credit cards as a form of payment?
              </Tooltip>
            }
          >
            <TooltipIcon />
          </OverlayTrigger>
        </div>
        <div className="d-flex">
          <div className="radio-wrapper">
            <input ref={register({ required: true })} type="radio" value={true} name="credit" id="credit-yes" />
            <label htmlFor="credit-yes">Yes</label>
          </div>
          <div className="radio-wrapper">
            <input ref={register({ required: true })} type="radio" value={false} name="credit" id="credit-no" defaultChecked />
            <label htmlFor="credit-no">No</label>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <label htmlFor="payment_method">What payment types does your business accept? <span>*</span></label>
        <div className="tooltip-container-select">
          <MultySelect 
            onChangeHandler={onChangeHandler}
            handleMultiChange={handleMultiChange}
            name="payment_method"
            list={PAYMENT_TYPES}
            inputValue={inputValue.payment_method}
            selectValue={selectValue.filter(item => item.type === 'payment_method')}
            styles="react-select-container"
            prefixStyles="react-select"
            indicator={false}
            check={true}
          />
           <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip id="button-tooltip">
                  Select all methods of payment that your business will accept.
                </Tooltip>
              }
            >
              <TooltipIcon />
            </OverlayTrigger>
        </div>
      </fieldset>
      <fieldset>
        <div className="tooltip-container-label">
          <label htmlFor="discounts">Does your business provide quantity discounts? <span>*</span></label>
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip id="button-tooltip">
                Select all methods of payment that your business will accept.
              </Tooltip>
            }
          >
            <TooltipIcon />
          </OverlayTrigger>
        </div>
        <div className="d-flex">
          <div className="radio-wrapper">
            <input ref={register({ required: true })} type="radio" value={true} name="discounts" id="discounts-yes" />
            <label htmlFor="discounts-yes">Yes</label>
          </div>
          <div className="radio-wrapper">
            <input ref={register({ required: true })} type="radio" value={false} name="discounts" id="discounts-no" defaultChecked />
            <label htmlFor="discounts-no">No</label>
          </div>
        </div>
      </fieldset>
      <div className="terms-wrap">
        <div className="Checkbox_Wrap">
          <input
            label="terms"
            onChange={onChangeTermsHander}
            type="checkbox"
            name="agree"
            id="terms"
            checked={terms}
            ref={register()}
          />
          <label htmlFor="terms">I Agree to the <a href="#" target="_blank">Terms and Conditions</a><span>*</span></label>
        </div>
      </div>
      <button 
        type="submit"
        className="filledBtn btnSizes"
        disabled={!terms}
      >
        Complete Registration
      </button>
    </form>
  )
}

export default FrameFive;